import moment from 'moment-timezone';

export class ExternalApiData {

    public timestamp: string
    constructor(
        public actionName: string,
        public database: string,
        public path: string,
        public guid: string,
        public userId: string
    ) {
        moment(new Date()).utc();
        this.timestamp = moment(new Date()).utc().format();
    }

    public toJson(): string {
        return JSON.stringify(this);
    }
}
